import EventEmitter from "../../node_modules/eventemitter3/index";
import {
  Stage,
  StagesClient,
  Transition,
  TransitionsClient,
  WorkFlowChartClient,
  EmailTemplateClient,
  WebhookConfigurationsClient,
  WebhookConfiguration,
  UserAndRolesClient,
  RespuestasPredeterminadasClient,
  RespuestaPredeterminada,
} from "./client/Client";
import WorkFlowChartComponent from "./Components/WorkFlowChartComponent";
import StageComponent from "./Components/StageComponent";
import StagesTableComponent from "./Components/StagesTableComponent";
import TransitionComponent from "./Components/TransitionComponent";
import TransitionsTableComponent from "./Components/TransitionTableComponent";
import Store from "./Store";
import { TableFactory } from "./Utilities/Table";
import WebhookTableComponent from "./Components/WebhookTableComponent";
import WebhookComponent from "./Components/WebhookComponent";
import { UsuariosInternosService } from "./Services/UsuariosInternosService";

let baseUrl = ".";

// jQuery(document).ajaxError((event, jqxhr, settings, thrownError) => {
//     jqxhr.catch((x,y,z)=>Utilidades.handleJqueryAjaxError(x,"Error en peticion ajax","Error en peticion ajax"));
// } );


var eventEmiter = new EventEmitter();
let store = new Store();
let tableFactory = new TableFactory<Stage>();
let tableFactoryTransition = new TableFactory<Transition>();
let tableFactoryRespuestas = new TableFactory<RespuestaPredeterminada>();
let tableFactoryWebhook = new TableFactory<WebhookConfiguration>();
let stageClient = new StagesClient(baseUrl);
let transitionClient = new TransitionsClient(baseUrl);
let flowChartClient = new WorkFlowChartClient(baseUrl);
let emailTemplateClient = new EmailTemplateClient(baseUrl);
let webhookClient = new WebhookConfigurationsClient(baseUrl);
let userAnRoles = new UserAndRolesClient(baseUrl);
let respuestasPredeterminadasClient = new RespuestasPredeterminadasClient(baseUrl);

let _ = (id: string) => document.querySelector(id);
window.addEventListener("DOMContentLoaded", (event) => {
  if (_("#transition-main-form")) {
    new TransitionComponent(
      stageClient,
      eventEmiter,
      store,
      transitionClient,
      emailTemplateClient,
      );
    }
    
    if (_("#stage-main-form")) {
      new StageComponent(stageClient, eventEmiter, store,
      new UsuariosInternosService(baseUrl), userAnRoles);
  }

  if (_("#stages-table")) {
    new StagesTableComponent(eventEmiter, tableFactory, stageClient);
  }

  if (_("#transitions-table")) {
    new TransitionsTableComponent(
      eventEmiter,
      tableFactoryTransition,
      tableFactoryRespuestas,
      transitionClient, 
      respuestasPredeterminadasClient
    );
  }

  if (_("#workflow")) new WorkFlowChartComponent(flowChartClient, eventEmiter);
  if (_("#webhook-main-form")) new WebhookTableComponent(tableFactoryWebhook,webhookClient, eventEmiter);
  if (_("#webhook-main-form")) new WebhookComponent(webhookClient, eventEmiter, stageClient);
});
